// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_TlTGDjYjM",
    "aws_user_pools_web_client_id": "18rjgv7kjid0at2v8kraf05r0e",
    "oauth": {}
};


export default awsmobile;
